import { ReactNode, createContext, useContext } from 'react';
import { ComplianceState } from '../../types/complianceTypes';
import { ComplianceType, ComplianceTypes, QuestionsSubmitData } from '../ComplianceModal/types';
import { HandlePaymentRequestResponse, SellerComplianceStateType, OpenLegalDocInteractionModalProps } from './types';

export interface ComplianceApi {
    getCompliance: () => Promise<ComplianceState>;
    getBackgroundCheckResultFile: ({ externalVendorId }: { externalVendorId: string }) => void;
    handlePayment: ({
        complianceType,
        currency,
        requesteeId,
        classificationAnswers,
        discountInPercents,
        requeseteeUserName,
        templateIds,
        isFree,
    }: {
        requesteeId: number;
        complianceType: ComplianceType;
        currency?: string;
        classificationAnswers?: QuestionsSubmitData;
        discountInPercents?: number;
        requeseteeUserName: string;
        templateIds?: string[];
        isFree?: boolean;
    }) => Promise<HandlePaymentRequestResponse>;
}

export interface Context {
    complianceData: ComplianceState | null;
    api: ComplianceApi;
    popupApi: {
        open: (callback: () => ReactNode) => void;
        close: () => void;
    };
    openModal: (requeseteeId: number, complianceType: ComplianceTypes, requeseteeUserName: string) => void;
    openLegalDocsInteractionModal: (props: OpenLegalDocInteractionModalProps) => void;
    getSellerComplianceState: (sellerId: number) => SellerComplianceStateType;
    pageName: string;
}

export const ComplianceContext = createContext<Context | null>(null);

export const useComplianceContext = () => useContext(ComplianceContext);
